import { z } from 'zod'
import type { Invitation } from '#/domain/invitation/Invitation'
import type { InvitationPage } from '#/domain/invitation/InvitationRepository'

const InviteeDtoSchema = z.object({
  Name: z.string().optional(),
  Email: z.string().optional(),
})

export const InvitationDtoSchema = z
  .object({
    Id: z.string().optional(),
    Invitee: InviteeDtoSchema,
    Roles: z.array(z.string()),
    Inviter: InviteeDtoSchema.optional(),
    ClientId: z.string().optional(),
    ConnectionId: z.string().optional(),
    CreatedAt: z.string().optional(),
    ExpiresAt: z.string().optional(),
  })
  .transform((raw): Invitation => ({
    Id: raw.Id,
    Invitee: raw.Invitee,
    Roles: raw.Roles,
    Inviter: raw.Inviter,
    ClientId: raw.ClientId,
    ConnectionId: raw.ConnectionId,
    CreatedAt: raw.CreatedAt,
    ExpiresAt: raw.ExpiresAt,
  }))

export type InvitationResponseDto = z.input<typeof InvitationDtoSchema>

export function toDomain(raw: InvitationResponseDto): Invitation {
  return InvitationDtoSchema.parse(raw)
}

export function toDomainList(raw: InvitationResponseDto[]): Invitation[] {
  return raw.map(toDomain)
}

const InvitationPageDtoSchema = z
  .object({
    Items: z.array(InvitationDtoSchema),
    Length: z.number(),
    Total: z.number(),
  })
  .transform((raw): InvitationPage => ({
    items: raw.Items,
    total: raw.Total,
    length: raw.Length,
  }))

export type InvitationPageResponseDto = z.input<typeof InvitationPageDtoSchema>

export function toDomainPage(raw: InvitationPageResponseDto): InvitationPage {
  return InvitationPageDtoSchema.parse(raw)
}
